<template>
    <div>
        <div class="columns toolbar-box action-right">
            <div class="column is-2">
                <h1 class="title is-3 between-center">
                    <span>
                        <span>Users</span>
                        <a href="#" @click.prevent="isTableSettingsModalActive = true" class="gear">
                            <o-icon pack="fa" icon="gear" size="is-small"/>
                        </a>
                    </span>
                </h1>
            </div>
            <div class="column is-6-tablet is-2-desktop">
                <o-field>
                    <o-input
                            type="search"
                            v-model="filters.name"
                            placeholder="Name"
                            icon="search"
                            @change.native="fetchPaginatedData(true)"
                    />
                </o-field>
            </div>
            <div class="column is-6-tablet is-2-desktop">
                <o-field>
                    <o-input
                            type="search"
                            v-model="filters.email"
                            placeholder="Email"
                            icon="search"
                            @change.native="fetchPaginatedData(true)"
                    />
                </o-field>
            </div>
            <div class="column is-5-tablet is-4-desktop action-box">
                <div class="field is-grouped is-grouped-right">
                    <p v-if="isResetFiltersButtonVisible" class="control">
                        <a @click.prevent="resetFilters" class="button is-info"><span>Reset filters</span></a>
                    </p>
                    <p v-if="isDeleteSelectedButtonVisible" class="control">
                        <a @click.prevent="handleUserDeletion" class="button is-danger"><span>Delete selected</span></a>
                    </p>
                    <p class="control">
                        <router-link :to="{ name: 'users.create' }" class="button is-info" ><span class="icon"><i
                                class="icm-new"></i></span><span>New</span></router-link>
                    </p>
                </div>
            </div>
        </div>
        <o-table
                class="fullwidth-table is-responsive is-responsive-xs-desktop"

                v-if="isTableVisible"
                :data="paginatedData"

                :bordered="table.bordered"
                :striped="table.striped"
                :narrowed="table.narrowed"
                :checkable="table.checkable"
                :mobile-cards="table.mobileCards"
                :paginated="table.paginated"
                :pagination-simple="table.paginationSimple"
                :per-page="table.perPage"
                :default-sort-direction="table.defaultSortDirection"
                :default-sort="[hasColumn('full_name') ? 'full_name' : 'first_name', 'asc']"

                :selected.sync="selected"
                :checked-rows="checkedRows"
@update:checkedRows="$event => checkedRows = $event"

                :loading="loading"
                :total="total"
                backend-sorting
                backend-pagination
                @page-change="onPageChange"
                @sort="onSort"
        >
            <template>
                <template>
                    <o-table-column
                            v-for="col in tableColumns"
                            v-bind="col"
                            #default="{ row }"
                            :field="col.field"
                            :label="col.field == 'actions' ? '' : col.label"
                            :sortable="col.sortable"
                    >
                        <router-link v-if="col.field === 'last_editor_id'"
                                     :to="{ name: 'users.show', params: { slug: row.last_editor_id } }">
                            {{ userNameById(row.last_editor_id) }}
                        </router-link>
                        <span v-if="col.field === 'email'">{{ row.email }}</span>
                        <span v-if="col.field === 'full_name'">
                            <router-link :to="`/users/${row.id}`">{{ row.full_name }}</router-link>
                        </span>
                        <span v-if="col.field === 'first_name'">
                            <router-link :to="`/users/${row.id}`">{{ row.first_name }}</router-link>
                        </span>
                        <span v-if="col.field === 'last_name'">
                            <router-link :to="`/users/${row.id}`">{{ row.last_name }}</router-link>
                        </span>

                        <span v-if="col.field === 'avatar_url'"><img :src="row.avatar_url"></span>
                        <span v-if="col.field === 'status'">{{ row.blocked ? 'Inactive' : 'Active' }}</span>
                        <span v-if="col.field === 'mobile'">{{ row.mobile }}</span>
                        <span v-if="col.field === 'phone_extension'">{{ row.phone_extension }}</span>
                        <span v-if="col.field === 'carrier'">{{ row.carrier }}</span>
                        <span v-if="col.field === 'title'">{{ row.title }}</span>
                        <span v-if="col.field === 'role'">{{ row.role }}</span>
                        <span v-if="col.field === 'blocked'">{{ $filters.yesNo(row.blocked) }}</span>
                        <span v-if="col.field === 'created_at'">{{ $filters.datetime(row.created_at) }}</span>
                        <span v-if="col.field === 'updated_at'">{{ $filters.datetime(row.updated_at) }}</span>

                        <o-dropdown v-if="col.field === 'actions'" hoverable position="bottom-left"
                                    class="table-actions">
                            <template class="button" v-slot:trigger>
                                <o-icon pack="fa" icon="ellipsis-v"></o-icon>
                            </template>
                            <o-dropdown-item has-link>
                                <router-link :to="{ name: 'users.show', params: { slug: row.id } }">View User
                                </router-link>
                            </o-dropdown-item>
                        </o-dropdown>
                    </o-table-column>
                </template>
            </template>

          <template v-slot:empty>
            <div class="has-text-centered">
              This table is empty!
            </div>
          </template>
        </o-table>

        <div>Total: <strong>{{ total }}</strong></div>

       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isTableSettingsModalActive" has-modal-card class="table-settings-modal">
            <table-settings-modal :slug="tableName"/>
        </o-modal>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex'
    import Table from '../../mixins/Table'

    export default {
        mixins: [Table],

        created() {
            this.filters = {
                name: '',
                email: ''
            }
        },

        mounted() {
            this.fetchPaginatedData()
            this.table.defaultSort = ['blocked', 'asc'];
            if (this.currentUserIsAdmin === false){
              this.$router.push(`/users/${this.currentUserId}`)
            }

        },

        data() {
            return {
                tableName: 'users-index',
            }
        },

        methods: {
            ...mapActions({
                fetchData: 'fetchUsers',
                removeItem: 'removeUser'
            }),

            handleUserDeletion() {
                this.checkedRows = _.filter(this.checkedRows, row => row.id != this.currentUserId)
                this.confirmCustomDelete()
            }
        },

        computed: {
            ...mapGetters({
                itemsByIds: 'usersByIds',
                currentUserId: 'currentUserId',
                userNameById: 'userNameById',
                currentUserIsAdmin: "currentUserIsAdmin"
            }),

            filteredUsers() {
                return this.users.filter((user) => {
                    for (let field in this.filters) {
                        let value = ''

                        if (user[field]) {
                            value = user[field].toLowerCase()
                        }

                        let filterValue = this.filters[field].toLowerCase()

                        if (!value.includes(filterValue)) {
                            return false
                        }
                    }

                    return true
                })
            }
        }
    }
</script>
